import { UserDefinedMaintenancePage } from "@/components/specific/userDefined";
import { UserDefinedItemType } from "@/types/domain";

export const CompanyUserDefinedMaintenancePage = () => {
  return (
    <UserDefinedMaintenancePage
      itemType={UserDefinedItemType.Company}
      entityType="UserDefCompany"
      title="Company User Defined Items"
      cacheKey="company_user_defined_sort"
    />
  );
};
